<template>
  <div id="box-modal">
    <div class="error-messages-modal-part" v-if="errorMessage">
      <ul class="error-list">
        <li class="error-message">
          {{ errorMessage }}
        </li>
      </ul>
    </div>
    <div class="input-fields-part">
      <div class="name">
        <basic-input
          type="number"
          :label="$t('storeScreen.boxModal.inputs.QRNumber.label')"
          :placeholder="$t('storeScreen.boxModal.inputs.QRNumber')"
          class="QRNumber-input row"
          v-model="QRNumber"
        />
      </div>
      <div class="type">
        <basic-select
          :placeholderText="$t('storeScreen.boxModal.inputs.type')"
          :label="$t('storeScreen.boxModal.inputs.type')"
          class="type-input"
          v-model="type"
        >
          <basic-select-item :value="0" :text="$variables.boxTypes[0]" />
          <basic-select-item :value="1" :text="$variables.boxTypes[1]" />
          <basic-select-item :value="2" :text="$variables.boxTypes[2]" />
        </basic-select>
      </div>
      <div class="code">
        <basic-input
          :disabled="codeDisabled"
          :label="$t('storeScreen.boxModal.inputs.code')"
          :placeholder="$t('storeScreen.boxModal.inputs.code')"
          class="code-input row"
          v-model="code"
        />
      </div>
      <div class="code-toggle">
        <transition name="fade">
          <inline-link
            :text="$t('storeScreen.boxModal.inputs.code.disabled')"
            v-if="codeDisabled"
            @inlineLinkClicked="codeAllowed"
          />
        </transition>
        <!-- <inline-link :text="" v-if="!codeDisabled" /> -->
      </div>
    </div>
    <div class="button-wrapper">
      <div>
        <rounded-button
          v-if="box && getActiveUser.role == 2"
          buttonType="danger"
          width="70%"
          height="30px"
          @click="archiveBox"
        >
          {{
            box.box_deleted
              ? $t("storeScreen.boxItem.button.delete")
              : $t("storeScreen.boxItem.button.archive")
          }}
        </rounded-button>
      </div>
      <div>
        <rounded-button
          :disabled="isButtonDisabled"
          @click="saveBox"
          width="70%"
          height="30px"
          :position="'right'"
        >
          {{ $t("storeScreen.boxModal.inputs.save") }}
        </rounded-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "boxModal",
  props: {
    box: {
      type: Object,
      required: false
    }
  },
  components: {},
  data: () => ({
    QRNumber: undefined,
    type: undefined,
    code: undefined,
    codeDisabled: true,
    errorMessage: undefined
  }),
  created() {
    if (this.box) {
      this.QRNumber = this.box.QRNumber;
      this.type = this.box.type;
      this.code = this.box.code;
    } else {
      this.nextQrNumber();
    }
  },
  watch: {
    QRNumber() {
      if (
        this.type !== undefined &&
        this.QRNumber !== undefined &&
        this.codeDisabled
      ) {
        this.code = `${this.$variables.boxTypes[this.type]}${this.QRNumber}`;
      }
    },
    type() {
      if (
        this.type !== undefined &&
        this.QRNumber !== undefined &&
        this.codeDisabled
      ) {
        this.code = `${this.$variables.boxTypes[this.type]}${this.QRNumber}`;
      }
    }
  },
  computed: {
    ...mapGetters({
      getActiveUser: "user/getActiveUser"
    }),
    isButtonDisabled() {
      return !(
        this.type !== undefined &&
        this.code !== undefined &&
        this.QRNumber !== undefined &&
        this.changedElements !== undefined
      );
    },
    changedElements() {
      let data = undefined;
      if (this.QRNumber !== undefined) {
        if (this.box) {
          if (this.QRNumber !== this.box.QRNumber) {
            if (data === undefined) {
              data = {};
            }
            data["QRNumber"] = this.QRNumber;
          }
        } else {
          if (data === undefined) {
            data = {};
          }
          data["QRNumber"] = this.QRNumber;
        }
      }

      if (this.type !== undefined) {
        if (this.box) {
          if (this.type !== this.box.type) {
            if (data === undefined) {
              data = {};
            }
            data["type"] = this.type;
          }
        } else {
          if (data === undefined) {
            data = {};
          }
          data["type"] = this.type;
        }
      }

      if (this.code !== undefined) {
        if (this.box) {
          if (this.code !== this.box.code) {
            if (data === undefined) {
              data = {};
            }
            data["code"] = this.code;
          }
        } else {
          if (data === undefined) {
            data = {};
          }
          data["code"] = this.code;
        }
      }
      return data;
    }
  },
  methods: {
    ...mapActions({
      readNextQrNumber: "boxes/readNextQrNumber",
      updateBox: "boxes/updateBox",
      createBox: "boxes/createBox",
      deleteBox: "boxes/deleteBox"
    }),
    archiveBox() {
      this.deleteBox({ id: this.box.box_id })
        .then(res => {
          if (res.status === "OK") {
            this.$emit("refreshData");
            this.$eventBus.closeModal();
            this.$notification.showNoti("success", "boxItem.delete.success");
          } else {
            this.$notification.showNoti("error", null, res);
          }
        })
        .catch(() =>
          this.$notification.showNoti("error", "boxItem.delete.success")
        );
    },
    saveBox() {
      const body = {
        ...this.changedElements
      };
      if (this.box) {
        this.boxUpdatingMethod(body);
      } else {
        this.boxCreatingMethod(body);
      }
    },
    boxCreatingMethod(body) {
      this.createBox(body)
        .then(res => {
          if (res.status === "OK") {
            this.$notification.showNoti("success", "boxModal.create.success");
            this.$eventBus.closeModal();
            this.$emit("refreshData");
          } else {
            this.errorMessage = res.errorMessage;
          }
        })
        .catch(() => {
          this.$notification.showNoti("error", "boxModal.create.error");
          this.$eventBus.closeModal();
        });
    },
    boxUpdatingMethod(body) {
      const data = {
        id: this.box.box_id,
        body
      };
      this.updateBox(data)
        .then(res => {
          if (res.status === "OK") {
            this.$notification.showNoti("success", "boxModal.update.success");
            this.$eventBus.closeModal();
            this.$emit("refreshData");
          } else {
            this.errorMessage = res.errorMessage;
          }
        })
        .catch(() => {
          this.$notification.showNoti("error", "boxModal.update.error");
          this.$eventBus.closeModal();
        });
    },
    codeAllowed() {
      this.codeDisabled = false;
    },
    nextQrNumber() {
      this.readNextQrNumber().then(res => {
        if (res.status === "OK") {
          this.QRNumber = res.data;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
#box-modal {
  padding: 10px;
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .input-fields-part {
    div {
      margin-bottom: 15px;
    }
    .code {
      margin-bottom: 5px !important;
    }
    .code-toggle {
      div {
        font-size: 14px;
        text-align: center;
      }
    }
  }
  .button-wrapper {
    display: flex;
    margin-top: 10px;
    div {
      width: 50%;
    }
  }
}
</style>
